module.exports = __webpack_public_path__ + "images/marketing/iphone6.png";